import script from "./ChildButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildButton.vue?vue&type=script&setup=true&lang=js"

import "./ChildButton.vue?vue&type=style&index=0&id=358af030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358af030"]])

export default __exports__